import React from 'react';
import Spinner from 'react-spinkit';
import { Row, Column } from 'react-foundation';

export const Loading = ({ msg }) => {
  return (
    <Row className="loading-container">
      <Column small={12}>
        <Spinner spinnerName="double-bounce" />
        {!msg ? null : <p className="loading-msg text-center">{msg}</p>}
      </Column>
    </Row>
  );
};



/** WEBPACK FOOTER **
 ** ./src/components/layout/loading.jsx
 **/